import { render } from "./TourManager.vue?vue&type=template&id=65a1b79c&scoped=true"
import script from "./TourManager.vue?vue&type=script&lang=js"
export * from "./TourManager.vue?vue&type=script&lang=js"

import "./TourManager.vue?vue&type=style&index=0&id=65a1b79c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a1b79c"]])

export default __exports__